import imgSrc from './400-error.png';
import imgSet2 from './400-error@2x.png';
import imgSet3 from './400-error@3x.png';

const imgSet = [imgSet2, imgSet3];

export {
    imgSrc,
    imgSet,
};
